import {MyShipmentDetail} from '../../services/models/MyShipmentDetail';
import {ShipmentUnitsSummaryWrapper} from '../shipment-commodity-summary/services/models/ShipmentUnitsSummaryWrapper';
import {ShipmentTimelineStep} from '../shipment-timeline-details/services/models/ShipmentTimelineStep';

export class MyCompleteShipment {
  myShipment: MyShipmentDetail;
  shipmentUnitsSummary: ShipmentUnitsSummaryWrapper;
  shipmentTimelineSteps: [ShipmentTimelineStep];
}
